import { zodResolver } from '@hookform/resolvers/zod';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from '@mui/material';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { AsyncSelect, ControlledTextField } from '../../../../../components/forms';
import { useLoadOptions } from "../../../../../hooks/useLoadOptions";
import { EntityWithIdAndDescriptionFields } from "src/lib/itaptec/http_client/src";
import { HttpLEP } from '../api/httpLEP';
import { useLEPEmisorTipos } from '../hooks/useLEPCache';
import { OperacionLEPEmisorInsert, schemaOperacionLEPEmisorInsert } from '../types/dto';
import { OperacionLEPEmisorFields } from '../types/fields';
import { useOperacion } from 'src/pages/sistema/hooks/useOperacion';

interface DialogAgregarEmisorProps {
    open: boolean;
    onClose: () => void;
    onSuccess: () => void;
}

export const DialogAgregarEmisor = ({ open, onClose, onSuccess }: DialogAgregarEmisorProps) => {
    const { idOperacion, codSistema } = useOperacion()

    const { control, handleSubmit, reset, formState: { isSubmitting } } = useForm<OperacionLEPEmisorInsert>({
        resolver: zodResolver(schemaOperacionLEPEmisorInsert),
        defaultValues: {
            [OperacionLEPEmisorFields.RazonSocial]: '',
            [OperacionLEPEmisorFields.CodOperacionLEPEmisorTipo]: 0
        }
    });

    const emisoresHooks = useLEPEmisorTipos(codSistema);

    const loadEmisores = useLoadOptions({
        data: emisoresHooks.emisorTipos,
        loading: emisoresHooks.isLoading,
        isError: emisoresHooks.isError,
        error: emisoresHooks.error
    });

    const onSubmit = async (data: OperacionLEPEmisorInsert) => {
        try {
            await HttpLEP.insertEmisores(idOperacion, [data]);
            toast.success('Emisor agregado correctamente');
            reset();
            onSuccess();
            onClose();
        } catch (error) {
            toast.error('Error al agregar el emisor');
        }
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>Agregar Emisor</DialogTitle>
            <form onSubmit={handleSubmit(onSubmit)}>
                <DialogContent>
                    <Grid container spacing={4}>
                        <Grid item xs={12}>
                            <ControlledTextField
                                name={OperacionLEPEmisorFields.RazonSocial}
                                control={control}
                                label="Razón Social"
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <AsyncSelect
                                name={OperacionLEPEmisorFields.CodOperacionLEPEmisorTipo}
                                control={control}
                                label="Tipo de Emisor"
                                loadOptions={loadEmisores}
                                valueField={EntityWithIdAndDescriptionFields.Id}
                                selectNotNulleable
                                fullWidth
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose} color="secondary">
                        Cancelar
                    </Button>
                    <Button type="submit" variant="contained" disabled={isSubmitting}>
                        Guardar
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
};
